import { IMAGES } from "../constants/config";

export const routerContent = {
  meta: {
    title: "Crush Emploi — Recrutement vidéo Gen Z",
    description:
      "Crush Emploi : l'app sociale de recrutement pour les 16–26 ans. Candidatures vidéo, crush mutuel.",
  },
  hero: {
    title: "Crush Emploi",
    tagline:
      "L'app sociale qui révolutionne la recherche d'emploi : candidatures vidéo, crush mutuel, postule en un clic.",
    image: IMAGES.heroes.candidat,
    imageAlt: "Illustration candidat Crush Emploi",
  },
  cards: [
    {
      id: "candidat",
      to: "/candidats",
      title: "Je suis candidat",
      description:
        "Like les offres, postule en vidéo et décroche ton job grâce au crush mutuel.",
      cta: "Rejoins la liste d'attente",
    },
    {
      id: "entreprise",
      to: "/entreprises",
      title: "Je suis une entreprise",
      description:
        "Découvrez motivation et personnalité en vidéo avant le premier entretien.",
      cta: "Pré-inscription entreprise",
    },
  ],
};
